/**
 * Created by jonas on 2022-10-27.
 */
import {MatrixUtils} from "./MatrixUtils";
import {TheCage} from "../TheCage";
import {TheCageGameMode} from "../server/TheCageGameMode";
import {TheCageSymbol} from "../reels/TheCageSymbol";
import {ReelUtils} from "./ReelUtils";
import {FreespinsFeatureFrameStates} from "../view/parts/FreespinsFeatures";
import {XBombSymbol} from "../reels/XBombSymbol";
import {TheCageGameData} from "../server/TheCageData";
import {TheCageIdleNormalPresentation} from "../gameflow/TheCageIdleNormalPresentation";

export class RestoreUtils {

    public static DEFAULT_STARTUP_REELS = [
        ["L1", "L1", "M2"],
        ["L3", "L2", "M1", "L5"],
        ["M2", "M3", "L3"],
        ["L2", "M1", "L2", "M2"],
        ["M1", "M3", "M3"],
        ["M4", "L2", "L3", "M5"],
        ["L1", "M2", "M3"],
    ]

    public static EMPTY_FREESPINS_MATRIX = [
        ["BLANK", "BLANK", "BLANK"],
        ["BLANK", "BLANK", "BLANK"],
        ["BLANK", "BLANK", "BLANK"],
        ["BLANK", "BLANK"],
        ["BLANK", "BLANK"],
        ["BLANK", "BLANK"],
        ["BLANK", "BLANK", "BLANK"],
        ["BLANK", "BLANK", "BLANK"],
        ["BLANK", "BLANK", "BLANK"],
    ]

    constructor() {

    }

    public static startupGame() {
        if (TheCage.model.initData.isRestoreState) {
            if (TheCage.model.data.nextMode == TheCageGameMode.FREESPIN) {
                if (TheCage.model.initData.freespinTriggeredThisSpin) {
                    RestoreUtils.restoreFreespinWithIntro();
                } else {
                    RestoreUtils.restoreFreespin();
                }
            } else if (TheCage.model.data.nextMode == TheCageGameMode.FREESPIN_AVALANCHE) {
                RestoreUtils.restoreDuringFreespinAvalanche();
            } else {
                RestoreUtils.restoreDuringAvalanche();
            }

        } else {
            RestoreUtils.normalStartUp();
        }
    }

    public static normalStartUp() {
        TheCage.backgroundElements.setMode(TheCage.model.data.nextMode);
        TheCage.reelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(TheCage.model.data.reels),
            TheCage.reelView.startPositions);
        TheCage.freeSpinReelView.avalancheMatrixModel.init(this.EMPTY_FREESPINS_MATRIX,
            TheCage.freeSpinReelView.startPositions);
    }

    public static resetToPlayBonusInGame(data: TheCageGameData) {
        TheCage.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        TheCage.model.onGame(data);
        TheCageIdleNormalPresentation.stopCompleteIdlePresentationForAS();
        TheCage.reelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(data.evaluatedArea), TheCage.reelView.startPositions);
        setTimeout(() => {
            TheCage.gameFlowController.start();
        }, 600);

    }

    public static restoreDuringAvalanche() {
        TheCage.backgroundElements.setMode(TheCage.model.data.nextMode);
        TheCage.reelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(TheCage.model.data.symbolsAfterTumbleForClient),
            TheCage.reelView.startPositions);
        TheCage.freeSpinReelView.avalancheMatrixModel.init(this.EMPTY_FREESPINS_MATRIX,
            TheCage.freeSpinReelView.startPositions);
        TheCage.reelView.multiplierDisplay.reset(TheCage.model.data.persistantBaseMultiplier);
        TheCage.reelView.avalancheMatrixModel.getAllSymbolsWithName("WB").forEach((sym) => {
            (<XBombSymbol>sym.positionable).instantIdleAnimation()
        })
        TheCage.keypadPlugin.setWin(TheCage.model.data.accumulatedRoundWin, true, TheCage.isWinBelowStake());
    }

    public static restoreFreespinWithIntro() {
        TheCage.backgroundElements.setMode(TheCageGameMode.NORMAL);
        TheCage.reelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(TheCage.model.initData.reelsEnteringFreespin),
            TheCage.reelView.startPositions);
        TheCage.freeSpinReelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(this.EMPTY_FREESPINS_MATRIX),
            TheCage.freeSpinReelView.startPositions);

        ReelUtils.resetScatter();
        ReelUtils.updateScatters();

        TheCage.keypadPlugin.setWin(TheCage.model.data.accumulatedRoundWin, true, TheCage.isWinBelowStake());
    }

    public static restoreFreespin() {
        // reel stuff
        TheCage.freeSpinReelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(TheCage.model.initData.reels),
            TheCage.freeSpinReelView.startPositions);
        TheCage.reelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(TheCage.model.initData.reelsEnteringFreespin),
            TheCage.reelView.startPositions);
        ReelUtils.resetScatter();
        ReelUtils.updateScatters();
        TheCage.reelView.hide();
        TheCage.freeSpinReelView.avalancheMatrixModel.getAllVisibleSymbols()
            .reduce((a, b) => a.concat(b), [])
            .filter((sym) => TheCage.model.initData.symbolSizes[sym.reelId][sym.reelPosition] > 1)
            .forEach((sym) => {
                (<TheCageSymbol>sym.positionable).setMultiplierInstant();
            });

        // fighters and meters
        const fsLevel = TheCage.model.initData.fsLevel;
        TheCage.freeSpinReelView.playerCounter.restore(fsLevel);
        TheCage.freeSpinReelView.opponentCounter.restore(fsLevel);
        TheCage.freeSpinReelView.opponent.restore(fsLevel, TheCage.model.initData.nBNcollectedInFSAfter[fsLevel]);
        TheCage.freeSpinReelView.opponent.idle();

        // feature frame
        const featureStates = TheCage.model.initData.featuresActive.map((featureActive, i) =>
            featureActive ? TheCage.model.initData.featuresUsedAfter[i] ? FreespinsFeatureFrameStates.ACTIVE_USED
                    : FreespinsFeatureFrameStates.ACTIVE
                : FreespinsFeatureFrameStates.INACTIVE
        );
        TheCage.freeSpinReelView.features.restore(fsLevel, featureStates);

        // views
        TheCage.backgroundElements.restoreFreespins();

        // show it
        TheCage.freeSpinReelView.restore();

        // keypad
        TheCage.keypadPlugin.setWin(TheCage.model.data.accumulatedRoundWin, true, TheCage.isWinBelowStake());

    }

    public static restoreDuringFreespinAvalanche() {
        TheCage.freeSpinReelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(TheCage.model.initData.symbolsAfterTumbleForClient),
            TheCage.freeSpinReelView.startPositions);
        TheCage.reelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(TheCage.model.initData.reelsEnteringFreespin),
            TheCage.reelView.startPositions);
        ReelUtils.resetScatter();
        ReelUtils.updateScatters();
        TheCage.reelView.hide();
        TheCage.freeSpinReelView.avalancheMatrixModel.getAllVisibleSymbols()
            .reduce((a, b) => a.concat(b), [])
            .filter((sym) => TheCage.model.initData.symbolSizesAfterTumble[sym.reelId][sym.reelPosition] > 1)
            .forEach((sym) => {
                (<TheCageSymbol>sym.positionable).setMultiplierInstant();
            });

        const fsLevel = TheCage.model.initData.fsLevel;
        TheCage.freeSpinReelView.playerCounter.restore(fsLevel);
        TheCage.freeSpinReelView.opponentCounter.restore(fsLevel);
        TheCage.freeSpinReelView.opponent.restore(fsLevel, TheCage.model.initData.nBNcollectedInFSAfter[fsLevel]);
        TheCage.freeSpinReelView.opponent.idle();

        // feature frame
        const featureStates = TheCage.model.initData.featuresActive.map((featureActive, i) =>
            featureActive ? TheCage.model.initData.featuresUsedAfter[i] ? FreespinsFeatureFrameStates.ACTIVE_USED
                    : FreespinsFeatureFrameStates.ACTIVE
                : FreespinsFeatureFrameStates.INACTIVE
        );
        TheCage.freeSpinReelView.features.restore(fsLevel, featureStates);

        TheCage.backgroundElements.restoreFreespins();

        TheCage.freeSpinReelView.restore();
        TheCage.keypadPlugin.setWin(TheCage.model.data.accumulatedRoundWin, true, TheCage.isWinBelowStake());
    }

    public static restoreAfterMaxWin() {
        TheCage.reelView.avalancheMatrixModel.init(MatrixUtils.cloneMatrix(RestoreUtils.DEFAULT_STARTUP_REELS),
            TheCage.reelView.startPositions);
        TheCage.keypadPlugin.setWin(TheCage.model.data.accumulatedRoundWin, true, TheCage.isWinBelowStake());
    }
}